import { DrdAttributeType } from "../../../../api/BrandKitApi";

// The dietary vocabulary: FDA top-9 allergens plus the fixed dietary tag set. The `attribute`
// key is the stable identifier persisted on a mapping and on a Data Kit item. DiningRD was the
// first consumer, not the only one - Data Kit items carry these same keys, and the venue's
// Brand Kit maps each key to an icon.
export interface DietaryAttribute {
  attribute: string;
  label: string;
  type: DrdAttributeType;
}

export const DIETARY_ATTRIBUTES: DietaryAttribute[] = [
  // Allergens (FDA top 9)
  { attribute: "MILK", label: "Milk", type: "ALLERGEN" },
  { attribute: "EGGS", label: "Eggs", type: "ALLERGEN" },
  { attribute: "FISH", label: "Fish", type: "ALLERGEN" },
  { attribute: "SHELLFISH", label: "Shellfish", type: "ALLERGEN" },
  { attribute: "TREE_NUTS", label: "Tree Nuts", type: "ALLERGEN" },
  { attribute: "PEANUTS", label: "Peanuts", type: "ALLERGEN" },
  { attribute: "WHEAT", label: "Wheat", type: "ALLERGEN" },
  { attribute: "SOYBEANS", label: "Soybeans", type: "ALLERGEN" },
  { attribute: "SESAME", label: "Sesame", type: "ALLERGEN" },
  // Dietary tags
  { attribute: "FRESH", label: "Fresh", type: "TAG" },
  { attribute: "GLUTEN_FREE", label: "Gluten Free", type: "TAG" },
  { attribute: "HIGH_FIBER", label: "High Fiber", type: "TAG" },
  { attribute: "HEART_HEALTHY", label: "Heart Healthy", type: "TAG" },
  { attribute: "MIND", label: "MIND", type: "TAG" },
  { attribute: "PESCETARIAN", label: "Pescetarian", type: "TAG" },
  { attribute: "SUGAR_FREE", label: "Sugar Free", type: "TAG" },
  { attribute: "VEGAN", label: "Vegan", type: "TAG" },
  { attribute: "VEGETARIAN", label: "Vegetarian", type: "TAG" },
];
